import { Component, OnInit } from '@angular/core';
import { IChaluka } from "./chaluka";
import { MatanotService } from "../matanot.service";
import { Router } from '@angular/router';

import { ChalukaFilterPipe } from "../shared/pipes/chaluka-filter-pipe";

@Component({
    moduleId: module.id,
    templateUrl: './chalukat-matanot.component.html',
    providers: [MatanotService]

})

export class ChalukatMatanotComponent implements OnInit {
    constructor(private _matanotService: MatanotService, private router: Router) { }

    chalukaList: IChaluka[];
    ms_zehut_filter: string;
    full_name_filter: string;
    phone_filter: string;
    filter: IChaluka = new IChaluka();

    sort: any = {
        column: 'ms_zehut', //to match the variable of one of the columns
        descending: false
    };

    ngOnInit(): void {
        this._matanotService.getChalukatMatanot()
            .subscribe(c => { this.chalukaList = c },
            error => {
                localStorage.removeItem("token");
                location.reload();
            })
    }

    selectedClass(columnName): string {
        return columnName == this.sort.column ? 'sort-' + this.sort.descending : 'false';
    }
    changeSorting(columnName): void {
        var sort = this.sort;
        if (sort.column == columnName) {
            sort.descending = !sort.descending;
        } else {
            sort.column = columnName;
            sort.descending = false;
        }
    }
    convertSorting(): string {
        return this.sort.descending ? '-' + this.sort.column : this.sort.column;
    }
    getCSSClasses(i) {
        if(i===1){
            return 'fa fa-check fa-check-mark'
        }
        else{
            return 'fa fa-times fa-times-mark'
        }
        
    }
    selected(item): void {
        this.router.navigate(['chalukat-matanot/update',
            { customer: JSON.stringify(item) }
        ]);
    }

}